/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_DomainInputs */



/**
* | output |
* | --- |
* | "That company account belongs to an email domain this workspace does not sign in with. Use your work address." |
*
* @param {Signin_Sso_X15_DomainInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_domain = /** @type {((inputs?: Signin_Sso_X15_DomainInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_DomainInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("That company account belongs to an email domain this workspace does not sign in with. Use your work address.")
});